export const style = {
	//padding: '5px',
	background:'#d8085b',
	fontColor:'white',
	position:'fixed',
	bottom:'0',
	left:'0',
	width:'100%'
};
